import { FilterOutlined } from "@ant-design/icons";
import { Button, Drawer, Form, Tag } from "antd";
import { useEffect, useState } from "react";

export default function FilterRow({ items, onChange, value, style }) {
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();

    useEffect(() => {
        form.resetFields();
        form.setFieldsValue(value.reduce((acc, curr) => ({ ...acc, [curr.name]: curr.value }), {}));
    }, [value]);

    const handleOnFinish = (form) => {
        console.log(form);
        const values = Object.entries(form)
            .filter(([_, v]) => v != null)
            .map(([k, v]) => {
                const item = items.filter((x) => x.name === k)[0];
                return {
                    value: v,
                    name: k,
                    readableName: item.label,
                    readableValue: item.readableValue?.(v) ?? v,
                };
            })
            .filter((x) => !!x.value);
        onChange(values);
        setOpen(false);
    };

    return (
        <div style={style}>
            <div style={{ display: "flex", flexDirection: "row", columnGap: 10 }}>
                <div
                    style={{
                        display: "flex",
                        flex: 1,
                        flexDirection: "row",
                        columnGap: 5,
                        alignItems: "center",
                    }}
                >
                    {value.length > 0 && <>Filtri:</>}
                    {value.map((x) => {
                        const item = items.filter((y) => y.name === x.name)[0];
                        return (
                            <Tag
                                key={x.name}
                                closable
                                style={{ fontSize: "1em" }}
                                onClose={() => onChange(value.filter((z) => z.name !== x.name))}
                            >
                                {item.label}: {item.readableValue?.(x.value) ?? x.value}
                            </Tag>
                        );
                    })}
                </div>
                <Button
                    color="primary"
                    variant={value.length > 0 ? "filled" : "link"}
                    icon={<FilterOutlined />}
                    onClick={() => setOpen(true)}
                >
                    Filtri
                </Button>
            </div>
            <Drawer forceRender open={open} closable onClose={() => setOpen(false)} title="Filtri">
                <Form
                    onFinish={(form) => {
                        handleOnFinish(form);
                    }}
                    initialValues={items
                        .filter((x) => x.initialValue != null)
                        .reduce((acc, x) => ({ ...acc, [x.name]: [x.initialValue] }), {})}
                    layout="vertical"
                    style={{ height: "100%", display: "flex", flexDirection: "column" }}
                    form={form}
                >
                    <div
                        style={{
                            flex: "1 1 0",
                            overflow: "auto",
                            scrollbarWidth: "thin",
                            scrollbarGutter: "stable",
                        }}
                    >
                        {(items ?? []).map((x) => (
                            <Form.Item
                                key={x.name}
                                name={x.name}
                                label={x.label}
                                {...x.formItem.props}
                            >
                                {x.formItem.children}
                            </Form.Item>
                        ))}
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "end",
                            columnGap: 16,
                        }}
                    >
                        <Button
                            onClick={() => {
                                form.resetFields();
                                onChange([]);
                                setOpen(false);
                            }}
                        >
                            Reset
                        </Button>
                        <Button type="primary" htmlType="submit">
                            Applica
                        </Button>
                    </div>
                </Form>
            </Drawer>
        </div>
    );
}
